"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { useEffect, useMemo } from "react";
import { FlowActions } from "../../stores/flowStore";
export const useSetQuoteItemsFragment = graphql(`
  fragment useSetQuoteItems on ItemQuoteResult {
    __typename
    ... on ItemQuote {
      item {
        tokenId
        contractAddress
        chain {
          identifier
        }
      }
      quantity
      pricePerItem {
        token {
          unit
          contractAddress
        }
      }
      orderId
    }
  }
`);
export function useSetQuoteItems(itemQuoteKeys) {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] !== itemQuoteKeys) {
    t1 = itemQuoteKeys?.flatMap(_temp) ?? [];
    $[0] = itemQuoteKeys;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  t0 = t1;
  const itemQuotesInput = t0;
  let t2;
  let t3;
  if ($[2] !== itemQuotesInput) {
    t2 = function setItemQuotesInFlowStore() {
      FlowActions.setItemQuotes(itemQuotesInput);
    };
    t3 = [itemQuotesInput];
    $[2] = itemQuotesInput;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
}
function _temp(itemQuoteKey) {
  const itemQuote = readFragment(useSetQuoteItemsFragment, itemQuoteKey);
  if (itemQuote.__typename !== "ItemQuote") {
    return [];
  }
  return [{
    orderId: itemQuote.orderId ?? undefined,
    item: {
      tokenId: itemQuote.item.tokenId,
      contractAddress: itemQuote.item.contractAddress,
      chain: itemQuote.item.chain.identifier
    },
    quantity: itemQuote.quantity,
    pricePerItem: {
      contractAddress: itemQuote.pricePerItem.token.contractAddress,
      unit: itemQuote.pricePerItem.token.unit.toString()
    }
  }];
}